import { MoreHorizontal } from 'lucide-react';

import { Button } from '@/components/ui/button';

/**
 * The fleet list's per-row ⋮ button. It opens `ServerRowActions`, which renders
 * the detail page's own `ActionMenu` for this server, so the row menu cannot
 * drift from it. It used to render its own item list, wired to nothing
 * (planet-proxy-KB#883).
 */
export function RowKebab({
  name,
  onOpen,
}: {
  name: string;
  onOpen: (name: string) => void;
}): JSX.Element {
  return (
    <Button
      variant="ghost"
      size="sm"
      className="h-7 w-7 p-0"
      aria-label={`Actions for ${name}`}
      onClick={(e) => {
        e.stopPropagation();
        onOpen(name);
      }}
    >
      <MoreHorizontal className="h-4 w-4" aria-hidden />
    </Button>
  );
}
